import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/accessibility/cancelRequest.ts
import { Exception } from "@wbk/logger";
var cancelAccessibilityRequest = (_0) => __async(null, [_0], function* ({ id }) {
  try {
    const data = yield fetchClient({
      url: `/accessibility-profile/${id}/cancel`,
      options: {
        method: "POST"
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "cancelAccessibilityRequestException"
    });
  }
});

export {
  cancelAccessibilityRequest
};
//# sourceMappingURL=chunk-POY332AO.mjs.map